export const MARKER_HOVER_DELAY_MS = 600;
